/* ============================================================
   PebbleBloom - Offer Stack
   File: assets/pb-offer-stack.js

   Moves the offer stack into the buy box directly above Add to
   cart, and wires the bundle buttons to the theme's quantity
   input.

   The product has a single variant, so a bundle option is a
   quantity, not a variant switch. Setting the input and firing a
   change event is therefore the whole mechanism - the existing
   product form submits it unchanged.

   Purely additive. Without the script the stack still renders in
   place further down the page and the theme's own quantity
   stepper still works.
   ============================================================ */

(function () {
  'use strict';

  function relocate(stack) {
    var info = document.querySelector('.product__info-container');
    if (!info) return null;

    // Above the buy buttons, below the quantity - the last thing
    // read before committing.
    var form =
      info.querySelector('.product-form__buttons') ||
      info.querySelector('[name="add"]');
    var anchor = form ? form.closest('div') : null;
    if (!anchor || !anchor.parentNode) return null;

    anchor.parentNode.insertBefore(stack, anchor);

    /* The trust chips move below the buttons, and the buttons are what
       they belong to. Free shipping, returns and COD are not reasons to
       pick a bundle - they are the objections that surface in the second
       before someone commits, so they read better as reassurance under
       the button than as another line of detail above it. Both Add to
       cart and Buy it Now live inside .product-form__buttons, so
       inserting after that container clears the whole pair. */
    var chips = stack.querySelector('[data-pb-offer-chips]');
    if (chips) {
      chips.classList.add('pb-os__chips--under-buttons');

      /* Payment icons come first. "Can I pay the way I want" is the
         question still live while the thumb is on the button, so the icons
         answer it immediately and the chips close on shipping and returns
         underneath.

         Anchored on the payment block itself rather than on a sibling of
         the buttons: the buttons sit inside the product form and the icons
         sit outside it, so the two never share a parent. Only used when the
         icons genuinely follow the buttons - a page without the block, or
         with it placed higher up, keeps the chips directly under them. */
      var pay = info.querySelector('.footer__payment');
      var payFollows =
        pay &&
        (anchor.compareDocumentPosition(pay) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;

      if (payFollows) {
        pay.parentNode.insertBefore(chips, pay.nextSibling);
      } else {
        anchor.parentNode.insertBefore(chips, anchor.nextSibling);
      }
    }

    var host = document.querySelector('.pb-os-section');
    if (host && !host.querySelector('[data-pb-offer-stack]')) {
      host.style.display = 'none';
    }
    return info;
  }

  function wire(stack, info) {
    var qtyInput =
      info.querySelector('.quantity__input') ||
      info.querySelector('input[name="quantity"]');
    var buttons = stack.querySelectorAll('[data-pb-qty]');
    if (!buttons.length) return;

    function select(btn) {
      Array.prototype.forEach.call(buttons, function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      if (!qtyInput) return;
      var q = parseInt(btn.getAttribute('data-pb-qty'), 10) || 1;
      if (String(qtyInput.value) === String(q)) return;
      qtyInput.value = q;
      // The theme owns the stepper and its price/subtotal logic, so
      // notify rather than trying to reimplement it.
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    Array.prototype.forEach.call(buttons, function (b) {
      b.addEventListener('click', function () {
        select(b);
      });
    });

    // The bundle cards now set quantity, so the theme's stepper is a
    // second control for the same value - two inputs that can
    // disagree. Marked on the container rather than hidden here, so
    // the CSS only hides it when the stack actually took over.
    if (qtyInput) info.classList.add('pb-os-active');

    var preselected = stack.querySelector('[data-pb-qty].is-selected') || buttons[0];
    select(preselected);

    // If the visitor uses the theme's own stepper, keep the cards in
    // step rather than letting the two disagree.
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var v = String(qtyInput.value);
        Array.prototype.forEach.call(buttons, function (b) {
          var on = b.getAttribute('data-pb-qty') === v;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-pb-offer-stack]'),
      function (stack) {
        if (stack.dataset.pbOsInit === '1') return;
        stack.dataset.pbOsInit = '1';
        var info = relocate(stack);
        if (info) wire(stack, info);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
